import Header from "../components/Header";
import SimpleTable from "../components/SimpleTable";

export default function Balances() {
  return (
    <div className="space-y-3 sm:space-y-4">
      <Header title="Retailer Balances (Regular & Smart)" />
      <SimpleTable
        headers={["Retailer (Code)", "Regular Balance", "Smart Balance", "Total", "Last Payment"]}
        rows={[["Maha Mobile Hub (RT-1001)", "₹ 8,000", "₹ 4,500", "₹ 12,500", "2025-09-20"], ["Ganesh Telecom (RT-1002)", "₹ 1,200", "₹ 2,200", "₹ 3,400", "2025-09-17"], ["Sai Krupa (RT-1003)", "₹ 0", "₹ 0", "₹ 0", "2025-09-22"]]}
      />
    </div>
  );
}